/**
 * Imposes an application timeout. Forces user session to end via sign out.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import _ from "underscore";

const channel = Radio.channel("global");
const sessionTimeout = 55;

class Timeout extends Marionette.Object {
  initialize() {
    this.sessionTimeout = sessionTimeout * 60 * 1000;
    this.delay = null;

    this._setTimeout();

    // intercept ajax calls
    jQuery.ajaxSetup({
      beforeSend: this._onBeforeAjaxSend.bind(this),
    });
  }

  _setTimeout() {
    if (this.delay !== null && _.isNumber(this.delay)) {
      // clear previous timeout
      window.clearTimeout(this.delay);
    }

    // set delay
    this.delay = _.delay(this._onTimeout, this.sessionTimeout);
  }

  _onTimeout() {
    channel.trigger("auth:signout", true);
  }

  _onBeforeAjaxSend() {
    // reset timeout
    this._setTimeout();
  }
}

export { Timeout as default };
